import store from '@state/store'
import lazyLoadView from "./lazyload-view";
import routeError from "./route-error";
import formatDate from '@utils/format-date'

export default [
  {
    // 商品 CheckOut
    path: '/:merchantAlias/:productType/:productId/checkout',
    name: 'checkout',
    component: () => lazyLoadView(import('@views/checkout/index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        const cartIsEmpty = Object.keys(store.state.booking.cachedCart).length === 0;

        if (cartIsEmpty) {
          next({
            name: 'booking-product',
            params: {
              merchantAlias: routeTo.params.merchantAlias,
              productType: routeTo.params.productType,
              productId: routeTo.params.productId,
            },
            query: {
              language: routeTo.query.language || routeFrom.query.language
            }
          })
        } else {
          try {
            routeTo.params.checkoutCart = store.state.booking.cachedCart;

            next()
          } catch (error) {
            routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
          }
        }
      },
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      checkoutCart: route.params.checkoutCart,
      checkoutType: 'product'
    }),
  },
  {
    path: '/:merchantAlias/product/:productId/checkout/:orderKey',
    name: 'checkout-unpaid',
    component: () => lazyLoadView(import('@views/checkout/index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const currentOrder = await store.dispatch('booking/fetchOrder', {
            orderKey: routeTo.params.orderKey,
          });

          const { status: currentOrderStatus } = currentOrder.items;
          const { paymentMethod: currentOrderPaymentMethod } = currentOrder.items;

          if (currentOrderStatus !== 2) {
            const statusTextMap = {
              0: '已取消',
              1: '已付款',
              3: '已付款',
              4: '已付款',
            };

            alert(`您的結緣${statusTextMap[currentOrderStatus]}\n系統將重新導向至結緣詳情頁面⋯⋯`);

            next({
              name: 'order-detail',
              params: {
                merchantAlias: routeTo.params.merchantAlias,
                orderKey: routeTo.params.orderKey
              },
              query: {
                language: routeTo.query.language || routeFrom.query.language
              }
            })
          }

          if(currentOrderPaymentMethod === 'Vacc') {
            alert(`您的結緣無法線上付款，需使用ATM轉帳\n系統將重新導向至結緣詳情頁面⋯⋯`);

            next({
              name: 'order-detail',
              params: {
                merchantAlias: routeTo.params.merchantAlias,
                orderKey: routeTo.params.orderKey
              },
              query: {
                language: routeTo.query.language || routeFrom.query.language
              }
            })
          }

          if(currentOrder.items.paymentMethod === 'prepaid' && !currentOrder.items.prepaid) {
            next({
              name: 'order-detail',
              params: {
                merchantAlias: routeTo.params.merchantAlias,
                orderKey: routeTo.params.orderKey
              },
              query: {
                language: routeTo.query.language || routeFrom.query.language
              }
            })
          }

          store.dispatch('merchant/updateMerchant', currentOrder.items.merchant);

          const date = () => {
            switch (currentOrder.items.productType) {
              case 'light':
              case 'worshipset':
                return currentOrder.items.startDate.toString().substr(0, 4);
              case 'treasury':
              case 'pudu':
              case 'puja':
                return currentOrder.items.startDate.toString().substr(0, 7);
            }
          };

          const timeDate = () => {
            return currentOrder.items.startDate ? currentOrder.items.startDate.toString().substr(8, 2) : undefined
          };

          routeTo.params.order = currentOrder.items;
          routeTo.params.checkoutCart = {
            product: {
              alias: currentOrder.items.productAlias,
              type: currentOrder.items.productType,
              // merchantAlias: currentOrder.merchant.alias,
              name: currentOrder.items.productName,
            },
            paramsPriceTotal: currentOrder.items.priceTotal,
            paramsSizeTotal: currentOrder.items.groupSize,
            params: currentOrder.items.params,
            time: {
              title: currentOrder.items.inventoryTitle || undefined,
              date: timeDate(),
              startTime: currentOrder.items.startDate ? formatDate(currentOrder.items.startDate, 'time') : undefined,
              endTime: currentOrder.items.endDate ? formatDate(currentOrder.items.endDate, 'time') : undefined,
            },
            date: date(),
            merchantAlias: currentOrder.items.merchant.alias,
            couponInfo: {
              title: currentOrder.items.couponTitle || undefined,
              code: currentOrder.items.couponCode   || undefined
            },
            paramsPriceBase: currentOrder.items.priceBase,
            prepaid: currentOrder.items.prepaid
          };

          next()
        } catch (error) {
          routeError(error, routeTo,  next({ name: '404', params: { resource: 'Order' } }));
        }
      },
      authRequired: false,
      showLoginButton: true,
    },
    props: (route) => ({
      order: route.params.order || {},
      checkoutCart: route.params.checkoutCart,
      checkoutType: 'product',
    }),
  },
]
